const experiences = [
  {
    company: "Al Jazeera Media Network",
    roles: [
      {
        title: "VP of Mobile Innovation",
        dates: "Dec 2019 – Present",
        location: "Washington, D.C.",
        description:
          "Working directly for the CTO of Al Jazeera's digital division, responsible for digital innovation focusing on mobile applications and the future of journalistic content dissemination and consumption.",
      },
    ],
  },
  {
    company: "Ripl, Inc.",
    roles: [
      {
        title: "Director, Board of Directors",
        dates: "Sep 2019 – Present",
        location: "Bellevue, WA",
        description:
          "Providing strategic guidance to the business as a member of Ripl's board of directors.",
      },
      {
        title: "Tech Founder & CEO",
        dates: "Oct 2015 – Sep 2019",
        location: "Bellevue, WA",
        description:
          "Founded and led Ripl, the first mobile app enabling small business owners to create animated social media posts across Facebook, Twitter, and Instagram. Grew the business from $0 to $10M ARR in 2.5 years. Won GeekWire App of the Year and recognized as one of Seattle's 100 Best Companies to Work For.",
      },
    ],
  },
  {
    company: "The Attic Learning Community",
    roles: [
      {
        title: "Board Treasurer",
        dates: "Dec 2018 – Present",
        location: "Woodinville, WA",
        description:
          "Guiding the organization toward its mission of nurturing in children a sense of self, a passion for learning, community and childhood. Focused on fiscal responsibility as treasurer.",
      },
    ],
  },
  {
    company: "Fanzo",
    roles: [
      {
        title: "Tech Founder & CEO",
        dates: "Jan 2012 – Oct 2015",
        location: "Kirkland, WA",
        description:
          "Built a mobile platform that gave sports fans fast access to the best team content by listening to social media conversations, scoring and ranking content and fans. Graduated from the Techstars accelerator program.",
      },
    ],
  },
  {
    company: "Smilebox",
    roles: [
      {
        title: "CTO & Co-Founder",
        dates: "Feb 2005 – Jan 2012",
        location: "Redmond, WA",
        description:
          "Co-founded and built Smilebox from the ground up. Led the development team and defined technical direction, architecting the product and team from start to finish. Achieved over 20 million downloads and 220 million shares.",
      },
    ],
  },
  {
    company: "RealNetworks",
    roles: [
      {
        title: "RealArcade Development Manager",
        dates: "Dec 1997 – Jan 2005",
        location: "Greater Seattle Area",
        description:
          "Managed the agile development team for RealArcade, one of the first internet game distribution services. Also worked on RealProducer, RealSlideshow, and RealMedia Encoder for Adobe Premiere.",
      },
    ],
  },
  {
    company: "Asymetrix",
    roles: [
      {
        title: "Software Engineer",
        dates: "Jul 1995 – Dec 1997",
        location: "Bellevue, WA",
        description:
          "Developed Digital Video Producer, a modern nonlinear video editor. Also built 3D F/X and Web 3D, easy-to-use 3D art generation programs using C++ and MFC.",
      },
    ],
  },
  {
    company: "Legent",
    roles: [
      {
        title: "Software Engineer",
        dates: "May 1994 – Jul 1995",
        location: "Bellevue, WA",
        description:
          "Helped develop a distributed object environment in C++ for rapid application development. Ported software to Win32s and Windows 95.",
      },
    ],
  },
];

export function Experience() {
  return (
    <section id="experience" className="section">
      <div className="section-inner">
        <h2 className="section-title">Experience</h2>
        <div className="timeline">
          {experiences.map((exp) =>
            exp.roles.map((role, i) => (
              <div className="timeline-item" key={`${exp.company}-${i}`}>
                <div className="timeline-company">{exp.company}</div>
                <div className="timeline-role">{role.title}</div>
                <div className="timeline-meta">
                  {role.dates} &middot; {role.location}
                </div>
                <p className="timeline-description">{role.description}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
